import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { LogOut, LayoutDashboard, Banknote, Boxes, Package, Settings } from 'lucide-react'
import clsx from 'clsx'

import { OrgSelector } from '@/components/OrgSelector'
import { useAuthStore } from '@/stores/auth'

const NAV_ITEMS = [
  { to: '/dashboard',        label: 'Dashboard & Rapportage', icon: LayoutDashboard, roles: ['superadmin', 'admin', 'user'] },
  { to: '/financierbaar',    label: 'Financierbaar',          icon: Banknote,        roles: ['superadmin', 'admin', 'user'] },
  { to: '/invoer/voorraad',  label: 'Invoer voorraad',        icon: Boxes,           roles: ['superadmin', 'admin', 'user'] },
  { to: '/invoer/materiaal', label: 'Invoer materiaal',       icon: Package,         roles: ['superadmin', 'admin', 'user'] },
  { to: '/beheer',           label: 'Beheer',                 icon: Settings,        roles: ['superadmin', 'admin'] },
]

export function Layout() {
  const user = useAuthStore((s) => s.user)
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const beschikbareItems = NAV_ITEMS.filter((i) => i.roles.includes(user?.rol ?? ''))

  return (
    <div className="min-h-screen flex bg-kh-gray-50">
      {/* Sidebar */}
      <aside className="w-64 bg-kh-blue text-white flex flex-col">
        <div className="px-5 py-6 border-b border-kh-blueDark">
          <img src="/merkteken.svg?v=3" alt="KapitaalHuys" className="h-11 w-11 bg-white rounded-lg p-1.5" />
          <p className="text-xs text-kh-gold mt-2 font-medium tracking-wide">
            Voorraadfinanciering
          </p>
        </div>

        <div className="pt-4">
          <OrgSelector />
        </div>

        <nav className="flex-1 px-3 py-2 space-y-1">
          {beschikbareItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors',
                  isActive
                    ? 'bg-kh-gold text-white font-medium'
                    : 'text-kh-gray-100 hover:bg-kh-blueLight'
                )
              }
            >
              <item.icon size={18} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-kh-blueDark text-sm">
          <div className="px-3 mb-3">
            <p className="font-medium">{user?.volledige_naam || user?.gebruikersnaam}</p>
            {user?.organisation_naam && (
              <p className="text-xs text-kh-gold">{user.organisation_naam}</p>
            )}
            <p className="text-xs text-kh-gray-300 capitalize">{user?.rol}</p>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-md
                       bg-kh-gold text-white text-sm font-medium hover:bg-kh-goldDark
                       transition-colors"
          >
            <LogOut size={16} /> Uitloggen
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-x-auto">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
